import React from 'react';
import { Button, Label } from 'govuk-react-jsx';
import { Link, useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getPMCData } from '../../features/pmc/pmcJourneySlice';
import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
} from '../../features/app/appSlice';
import useTitle from '../../hooks/useTitle';

const PmcClientConfirmBusinessDetails = () => {
  const companyDataRedux = useSelector(getPMCData);
  const history = useHistory();
  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);
  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;

  useTitle(
    'pmcClientReg.PmcClientConfirmBusinessDetails.s8',
    "Confirm your client's company details - OZEV Electric Vehicle Chargepoint Grant - GOV.UK"
  );

  const redirectCheckAnswers = () => {
    history.push('/pmcClientReg/check-your-answers');
  };

  const handleBtnClick = () => {
    redirectCheckAnswers();
  };

  const pageModel = (
    <>
      <div className="govuk-form-group">
        <Label
          className="govuk-label--xl govuk-!-padding-bottom-7"
          isPageHeading
        >
          {copyProvider.getCopy(
            'pmcReg.PmcClientConfirmBusinessDetails.s1',
            'Confirm the company details'
          )}
        </Label>
        <h2 className="govuk-heading-s">
          {copyProvider.getCopy(
            'pmcReg.PmcClientConfirmBusinessDetails.s2',
            'Company registration number'
          )}
        </h2>
        <p className="govuk-body govuk-!-font-size-19">
          {companyDataRedux && companyDataRedux.companyRegNumber}
        </p>
        <h2 className="govuk-heading-s">
          {copyProvider.getCopy(
            'pmcReg.PmcClientConfirmBusinessDetails.s3',
            'Company name'
          )}
        </h2>
        <p className="govuk-body govuk-!-font-size-19">
          {companyDataRedux && companyDataRedux.businessName}
        </p>
        <h2 className="govuk-heading-s">
          {copyProvider.getCopy(
            'pmcReg.PmcClientConfirmBusinessDetails.s4',
            'Registered company address'
          )}
        </h2>
        {companyDataRedux && (
          <div className="govuk-body govuk-!-font-size-19 govuk-!-margin-bottom-5">
            <section>
              {companyDataRedux.businessAddressLine1 &&
                `${companyDataRedux.businessAddressLine1},`}
            </section>
            <section>
              {companyDataRedux.businessAddressLine2 &&
                `${companyDataRedux.businessAddressLine2},`}
            </section>
            <section>
              {companyDataRedux.businessAddressCity &&
                `${companyDataRedux.businessAddressCity},`}
            </section>
            <section>
              {companyDataRedux.businessAddressCounty &&
                `${companyDataRedux.businessAddressCounty},`}
            </section>
            <section>
              {companyDataRedux.businessAddressPostcode &&
                companyDataRedux.businessAddressPostcode}
              {companyDataRedux.businessAddressCountry && ','}
            </section>
            <section>
              {companyDataRedux.businessAddressCountry &&
                companyDataRedux.businessAddressCountry}
            </section>
          </div>
        )}
        <div className="govuk-body govuk-!-font-size-19 govuk-!-margin-bottom-5">
          <section>
            {copyProvider.getCopy(
              'pmcReg.PmcClientConfirmBusinessDetails.s7',
              "Your client's company address may be different from the registered company address. If this is the case you may still proceed. We will not use this address to send any letters."
            )}
          </section>
        </div>
        <Link
          className="govuk-link govuk-body govuk-!-font-size-19"
          to="/pmcClientReg/company-registration-number"
        >
          {copyProvider.getCopy(
            'pmcReg.PmcClientConfirmBusinessDetails.s5',
            "This is not my client's business"
          )}
        </Link>
      </div>
      <Button className="govuk-button" onClick={handleBtnClick}>
        {copyProvider.getCopy(
          'pmcReg.PmcClientConfirmBusinessDetails.s6',
          'Confirm and continue'
        )}
      </Button>
    </>
  );
  return pageModel;
};

export default PmcClientConfirmBusinessDetails;
